module.exports = __webpack_public_path__ + "img/secure-3.af153f08.png";